<style>
@import '../../assets/css/report.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date_start')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.dateStart"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date_end')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.dateEnd"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_day')}}</template>
                        <b-button variant="primary" @click="searchDate('3days')" class="mr-2 mt-1">3 {{$t('admin.table_day')}}</b-button>
                        <b-button variant="primary" @click="searchDate('thisweek')" class="mr-2 mt-1">{{$t('admin.table_this_week')}}</b-button>
                        <b-button variant="primary" @click="searchDate('thismonth')" class="mr-2 mt-1">{{$t('admin.table_this_month')}}</b-button>
                        <b-button variant="primary" @click="searchDate('lastweek')" class="mr-2 mt-1">{{$t('admin.table_last_week')}}</b-button>
                        <b-button variant="primary" @click="searchDate('lastmonth')" class="mr-2 mt-1">{{$t('admin.table_last_month')}}</b-button>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_username')}}</template>
                        <b-input-group>
                            <b-form-input v-model="ajaxSearch.username" @keyup.enter="downlineSummary()"></b-form-input>
                            <b-input-group-append>
                                <b-button variant="primary" @click="downlineSummary()">{{$t('button.search')}}</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                    
                    <div v-if="ajaxShowDownline">
                        <b-form-group label-cols="4" label-cols-lg="4">
                            <template slot="label">{{$t('admin.table_select_user')}}</template>
                            <b-form-checkbox-group v-model="ajaxSearch.downline">
                                <b-row class="m-0">
                                    <b-form-checkbox v-for="(list,index) in downlineList" :key="index" :value="list.master_id" class="col">{{list.name}}</b-form-checkbox>
                                </b-row>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <b-form-group label-cols="12" label-cols-lg="4">
                            <template slot="label"></template>
                            <b-button variant="primary" @click="groupSummary()">{{$t('button.search')}}</b-button>
                        </b-form-group>
                    </div>
                    <!-- <p class="mt-3" style="color:#e60000">{{$t('report_summary.msg_summary')}}</p> -->
                </b-card>

                <b-row>
                    <!-- <b-col cols='12' md="6" class="mb-3">
                        <b-card header-tag="header">
                            <template slot="header">
                                <b>{{$t('report_summary.bonus_summary')}}</b>
                            </template>
                            <b-row>
                                <b-col cols="12" md="6" v-for="(bonusList,index) in ajaxTable.bonus_list" :key="index">
                                    <b-form-group label-cols="6" label-cols-lg="6">
                                        <template slot="label">{{bonusList.name}}</template>
                                        <label class="from-label">{{bonusList.total}}</label>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                    <b-col cols='12' md="6" class="mb-3">
                        <b-card header-tag="header">
                            <template slot="header">
                                <b>{{$t('report_summary.rank_summary')}}</b>
                            </template>
                             <b-row>
                                <b-col cols="12" md="6" v-for="(rankList,index) in ajaxTable.rank_list" :key="index">
                                    <b-form-group label-cols="5" label-cols-lg="5">
                                        <template slot="label">{{rankList.name}}</template>
                                        <label class="from-label">{{rankList.total_people}} {{$t('general.people')}}</label>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="12">
                                    <hr class="m-0">
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group label-cols="5" label-cols-lg="5">
                                        <template slot="label">{{$t('admin.table_amount')}}</template>
                                        <label class="from-label">{{ajaxTable.rank_total}} {{$t('general.people')}}</label>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col> -->
                    <b-col cols='12'>
                        <b-card header-tag="header" :header="$t($route.name)" style="overflow-x: scroll;">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" v-for="(tabTitle,index) in ajaxTable.tab_title" :key="index">{{tabTitle.label}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(content,index) in ajaxSummary" :key="index">
                                        <td>{{content.name}}</td>
                                        <td v-for="(wallet,indexWallet) in ajaxSummary[index].this_wallet" :key="indexWallet">
                                            {{wallet.coin}}<br>
                                            <span v-if="wallet.usdt > 0" style="color:#29a329">{{wallet.usdt}}</span> 
                                            <span v-if="wallet.usdt == 0" style="color:#000">{{wallet.usdt}}</span> 
                                            <span v-if="wallet.usdt < 0" style="color:#cc0000">{{wallet.usdt}}</span>
                                        </td>
                                        <td>
                                            {{content.total_usdt}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import {summaryInitialize,summaryGroup,summaryDownline} from '@/system/model/report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:{total_sum:''},
            ajaxSummary:[],
            ajaxSearch:{dateStart:'',dateEnd:'',username:'system',downline:'',type:'coin'},
            ajaxShowDownline:false,
            downlineList:[],
            titles:[],
            summaryType: this.$t('admin.table_coin_amount')
        }
    },methods:{
        initialize(){
            var self = this;
            var result = summaryInitialize();
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },downlineSummary(){
            this.ajaxSearch.downline = [];
            var self = this;
            var result = summaryDownline(this.ajaxSearch.username);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.downlineList = value.data.downline_list;
                    self.ajaxShowDownline = true;
                }
            });
        },groupSummary(){
            var self = this;
            var result = summaryGroup(this.ajaxSearch.dateStart,this.ajaxSearch.dateEnd,this.ajaxSearch.downline,this.ajaxSearch.username);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxTable = value.data;
                    self.ajaxSummary = value.data.data;
                    self.titles = value.data.tab_title;
                }
            });  
        },defaultDate(){
            var today = new Date();
            this.ajaxSearch.dateStart = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-01';
            this.ajaxSearch.dateEnd = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + (today.getDate())).slice(-2);
        },searchDate(date){
            var today = new Date();
            var todayDate = today.getDate();
            var todayMonth = today.getMonth();
            var todayYear = today.getFullYear();
            var filter = new Date();
            var filterDate;
            var filterMonth;
            var filterYear;

            if(date == '3days'){
                filter.setDate(filter.getDate() - 3);
                filterDate = filter.getDate();filterMonth = filter.getMonth();filterYear = filter.getFullYear();
            }else if(date == 'thisweek'){
                filter.setDate(filter.getDate() - 7);
                filterDate = filter.getDate();filterMonth = filter.getMonth();filterYear = filter.getFullYear();
            }else if(date == 'thismonth'){
                filterDate = 1;filterMonth = filter.getMonth();filterYear = filter.getFullYear();
                todayDate = 31;
            }else if(date == 'lastweek'){
                filter.setDate(filter.getDate() - 14);
                today.setDate(today.getDate() - 7);
                filterDate = filter.getDate();filterMonth = filter.getMonth();filterYear = filter.getFullYear();
                todayDate = today.getDate();todayMonth = today.getMonth();todayYear = today.getFullYear();
            }else if(date == 'lastmonth'){
                filterDate = 1;filterMonth = filter.getMonth()-1;filterYear = filter.getFullYear();
                todayDate = 31;todayMonth = today.getMonth()-1
            }
            this.ajaxSearch.dateStart = filterYear + '-' + ('0' + (filterMonth + 1)).slice(-2) + '-' + ('0' + filterDate).slice(-2);
            this.ajaxSearch.dateEnd = todayYear + '-' + ('0' + (todayMonth + 1)).slice(-2) + '-' + ('0' + todayDate).slice(-2);
            // (defaultDays)?this.initialize():'';
        }
    },created(){
        this.preloader(false);
        this.defaultDate();
        this.initialize();
    }
}
</script>
